<template>
	<div class="customSelect mdb-select md-form float-field form-control change-leverage-field" @click="$parent.selectAccount = !$parent.selectAccount" :class="($parent.selectAccount?'active' : '') || (($parent.account_id == '' && $parent.submitted)?'is-invalid' : '')">
		<div class="SelectAcntList">
			<div class="d-flex align-items-center justify-content-between" v-if="$parent.account_id == ''">
			
				<p v-if="$parent.pageName == 'Internal-transfer'">{{$t('TransFromAccId')}}</p><p v-else>{{$t('selectAccountId')}}</p></div>
				<div class="d-flex align-items-center justify-content-between" v-else>
					<span>
						<img :src="'../../../../static/fxView/images/'+platformIcon[$parent.platform]" class="mr-2" alt="Icon">
						{{$parent.account_id}} 
					</span>
					<small v-html="(parseInt($parent.demo_live) == 1)? $t('live') : $t('demo') "></small>
				</div>
		</div>
		<ul class="scrollbar" v-if="$parent.pageName == 'Internal-transfer'">
		<!--v-if="(parseInt(list.demo_live) == 1 && $parent.pageName == 'Internal-transfer') || $parent.pageName != 'Internal-transfer'"--->
			<li v-for="(list,key) in tradingAccountList.records" v-if="(parseInt(list.demo_live) == 1 && list.account_id != $parent.to_account_id)" @click="asignValueParentComponent(list)">
				<div class="aclist" > 
					<span>
						<img :src="'../../../../static/fxView/images/'+platformIcon[list.platform]" class="mr-2"  alt="Icon"> {{list.account_id}}  
					</span>
					<!-- <small v-html="(parseInt(list.demo_live) == 1)? $t('live') : $t('demo') "></small> -->
				</div>
			</li>
		</ul>
		<ul class="scrollbar" v-else-if="$parent.pageName == 'Change-Password' || $parent.pageName == 'Change-Leverage'">
		<!--v-if="(parseInt(list.demo_live) == 1 && $parent.pageName == 'Internal-transfer') || $parent.pageName != 'Internal-transfer'"--->
			<li v-for="(list,key) in tradingAccountList.records" @click="asignValueParentComponent(list)">
				<div class="aclist" > 
					<span>
						<img :src="'../../../../static/fxView/images/'+platformIcon[list.platform]" class="mr-2"  alt="Icon"> {{list.account_id}}  
					</span>
					<small v-html="(parseInt(list.demo_live) == 1)? $t('live') : $t('demo') "></small>
				</div>
			</li>
		</ul>
		<ul class="scrollbar" v-else>
		<!--v-if="(parseInt(list.demo_live) == 1 && $parent.pageName == 'Internal-transfer') || $parent.pageName != 'Internal-transfer'"--->
			<li v-for="(list,key) in tradingAccountList.records" v-if="parseInt(list.demo_live) == 1" @click="asignValueParentComponent(list)">
				<div class="aclist" > 
					<span>
						<img :src="'../../../../static/fxView/images/'+platformIcon[list.platform]" class="mr-2"  alt="Icon"> {{list.account_id}}  
					</span>
					<small v-html="(parseInt(list.demo_live) == 1)? $t('live') : $t('demo') "></small>
				</div>
			</li>
		</ul>
		<p class="error" v-if="($parent.submitted && $parent.account_id == '')">{{$t('fieldReq1')}}</p>
	</div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'Account-Id',
        mixins: [fxViewMixins],
        data() {
            return {
				platformIcon : {'MT4' : 'platforn-icon-1.svg' , 'MT5' : 'platforn-icon-3.svg','ACT' : 'platforn-icon-2.svg', 'ZULU' : 'zuluT.svg'},
            }
        },
        methods:{
            asignValueParentComponent(list){
				this.$parent.account_id = list.account_id 
				this.$parent.act_account_id = list.act_account_id  
				this.$parent.demo_live = list.demo_live 
				this.$parent.platform = list.platform 
				if(this.$parent.pageName && this.$parent.pageName == 'Change-Leverage'){
					this.$parent.exsisting_leverage = list.leverage
					this.$parent.leverage =	 ''				
				}else if((this.$parent.pageName) && (this.$parent.pageName == 'Bonus' || this.$parent.pageName == 'Remove-Bonus')){
					this.$parent.tradingBonus() 
				}else if(this.$parent.pageName && this.$parent.pageName == 'Withdrawal'){
					this.$parent.currencyData = list.currency 
					this.$parent.tradingAcountSelect() 
				}else if(this.$parent.pageName && this.$parent.pageName == 'Internal-transfer'){
					this.$parent.tradingBonus('from') 
					this.$parent.from_currency = list.currency
				}
		    }
        },
		mounted() { 
			const _that = this
            $(document).on("click", function(event){
				if(!$(event.target).closest('.SelectAcntList').length){
                    _that.$parent.selectAccount = false
                }
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/tradingAccounts/account_id.vue